export const APERTURA = '00APE'
export const COMPRAS = '01CMP'
export const VENTAS = '02VTA'
export const COBRANZAS = '03COB'
export const DIARIO = '04DIA'
export const PLANILLA = '05PLA'
export const CAJA_EGRESOS = '06EGR'
export const BANCOS = '07BCO'
export const CANJE_LETRAS = '08CNJ'
export const DEPRECIACIONES = '70DEP'
export const DIFERENCIA_TCAMBIO = '99DIF'

export const __dictionary = {
  [APERTURA]: { id: APERTURA, nombre: 'APERTURA' },
  [PLANILLA]: { id: PLANILLA, nombre: 'PLANILLA' },
  [CAJA_EGRESOS]: { id: CAJA_EGRESOS, nombre: 'CAJA - EGRESOS' },
  [BANCOS]: { id: BANCOS, nombre: 'BANCOS' },
  [DEPRECIACIONES]: { id: DEPRECIACIONES, nombre: 'DEPRECIACIONES' },
  [DIFERENCIA_TCAMBIO]: { id: DIFERENCIA_TCAMBIO, nombre: 'DIFERENCIA POR TC' },
  [VENTAS]: { id: VENTAS, nombre: 'VENTAS' },
  [COBRANZAS]: { id: COBRANZAS, nombre: 'COBRANZAS' },
  [COMPRAS]: { id: COMPRAS, nombre: 'COMPRAS' },
  [DIARIO]: { id: DIARIO, nombre: 'DIARIO' },
  [CANJE_LETRAS]: { id: CANJE_LETRAS, nombre: 'CANJE LETRAS' }
}

export const __array = [
  __dictionary[VENTAS],
  __dictionary[COBRANZAS],
  __dictionary[COMPRAS],
  __dictionary[DIARIO],
  __dictionary[CANJE_LETRAS],
  __dictionary[APERTURA],
  __dictionary[PLANILLA],
  __dictionary[CAJA_EGRESOS],
  __dictionary[BANCOS],
  __dictionary[DEPRECIACIONES],
  __dictionary[DIFERENCIA_TCAMBIO]
]

export default Object.freeze({
  VENTAS,
  COBRANZAS,
  COMPRAS,
  CANJE_LETRAS,
  DIARIO,
  CAJA_EGRESOS,
  BANCOS,
  __dictionary,
  __array
})
